import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const Retail = () => {
  return <PageTemplate title="Retail Solutions" subtitle="Modern Retail Technology" breadcrumb="Industries > Retail"><div className="content-section"><p>Retail technology solutions, AI-powered personalization, and omnichannel experiences.</p></div></PageTemplate>;
};
export default Retail; 